import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 min-h-[70vh] grid md:grid-cols-12 gap-12 items-center">
      <div className="md:col-span-7">
        <p className="font-mono text-[10px] uppercase tracking-widest text-destructive">
          Rejection Notice · 404
        </p>
        <h1 className="font-serif text-[10rem] md:text-[16rem] leading-[0.85] tracking-tighter mt-4">
          404.
        </h1>
        <p className="mt-6 max-w-md text-muted-foreground text-lg">
          This page didn't pass inspection. The Skeptic can't verify it exists, the Perfectionist won't ship it, and the Softie has never worn it.
        </p>
        <div className="mt-10 flex gap-4">
          <Link to="/" className="bg-foreground text-background px-8 py-4 font-mono text-xs uppercase tracking-[0.24em] hover:bg-[hsl(var(--accent))]">
            Back to the Hub
          </Link>
          <Link to="/shop" className="border border-foreground px-8 py-4 font-mono text-xs uppercase tracking-[0.24em] hover:bg-foreground hover:text-background">
            Enter the Shop
          </Link>
        </div>
      </div>
      <div className="md:col-span-5">
        <div className="border-2 border-destructive p-8 tag-punch pl-12" style={{ borderColor: "hsl(var(--destructive))" }}>
          <span className="stamp animate-stamp-in" style={{ borderColor: "hsl(var(--destructive))", color: "hsl(var(--destructive))" }}>
            ✕ REJECTED
          </span>
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-8">Inspector Notes</p>
          <p className="font-serif italic text-2xl mt-2">"URL failed authenticity check. Nothing to inspect here."</p>
          <p className="mt-4 font-mono text-[10px]">— K-01, The Skeptic</p>
        </div>
      </div>
    </div>
  );
}
